(function () {
  const FREE_REEL_VARIANT_ID = 54418093670705;
  const TOPPER_PRODUCT_TYPE = 'Interchangeable Badge Topper';
  const TOPPERS_REQUIRED = 3;

  let syncing = false;

  const originalFetch = window.fetch.bind(window);

  async function getCart() {
    const response = await originalFetch('/cart.js', {
      credentials: 'same-origin'
    });

    return response.json();
  }

  function countToppers(cart) {
    return cart.items.reduce((total, item) => {
      if (item.product_type === TOPPER_PRODUCT_TYPE) {
        return total + item.quantity;
      }

      return total;
    }, 0);
  }

  function findHeavyDutyReels(cart) {
    return cart.items.filter(
      item => Number(item.variant_id) === FREE_REEL_VARIANT_ID
    );
  }

  function findAutoAddedReel(cart) {
    return findHeavyDutyReels(cart).find(
      item =>
        item.properties &&
        item.properties._cbc_free_reel === 'true'
    );
  }

  async function syncFreeReel() {
    if (syncing) return;

    syncing = true;

    try {
      const cart = await getCart();

      const topperQuantity = countToppers(cart);
      const heavyDutyReels = findHeavyDutyReels(cart);
      const autoAddedReel = findAutoAddedReel(cart);

      // Customer qualifies and doesn't already have the reel.
      if (
        topperQuantity >= TOPPERS_REQUIRED &&
        heavyDutyReels.length === 0
      ) {
        await originalFetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id: FREE_REEL_VARIANT_ID,
                quantity: 1,
                properties: {
                  _cbc_free_reel: 'true'
                }
              }
            ]
          })
        });

        window.location.reload();
        return;
      }

      // If we automatically added the reel but the customer
      // no longer has 3 qualifying toppers, remove it.
      if (
        topperQuantity < TOPPERS_REQUIRED &&
        autoAddedReel
      ) {
        await originalFetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            id: autoAddedReel.key,
            quantity: 0
          })
        });

        window.location.reload();
      }
    } catch (error) {
      console.error(
        'Cherry Bomb Creations free reel auto-add:',
        error
      );
    } finally {
      syncing = false;
    }
  }

  // Watch Shopify cart requests so this also works
  // when products are added through the cart drawer.
  window.fetch = async function () {
    const response = await originalFetch.apply(null, arguments);

    try {
      const input = arguments[0];

      const url =
        typeof input === 'string'
          ? input
          : input && input.url;

      if (
        url &&
        /\/cart\/(add|change|update)(\.js)?(?:\?|$)/.test(url) &&
        !syncing
      ) {
        setTimeout(syncFreeReel, 250);
      }
    } catch (error) {
      // Don't interfere with Shopify if detection fails.
    }

    return response;
  };

  // Also check the cart whenever a page loads.
  document.addEventListener(
    'DOMContentLoaded',
    syncFreeReel
  );
})();